import { useLayoutEffect, useState } from "react"
import { getStoredTheme, persistTheme, type Theme } from "../lib/theme"

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => getStoredTheme() ?? "aetherdex")

  useLayoutEffect(() => {
    document.documentElement.setAttribute("data-theme", theme)
  }, [theme])

  const toggle = () => {
    const next = theme === "aetherdex" ? "light" : "aetherdex"
    setTheme(next)
    persistTheme(next)
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className="btn btn-ghost btn-sm btn-circle"
      aria-label="Toggle theme"
      title="Toggle theme"
    >
      {theme === "aetherdex" ? (
        <svg
          className="size-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          role="img"
          aria-label="Switch to light theme"
        >
          <title>Switch to light theme</title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      ) : (
        <svg
          className="size-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          role="img"
          aria-label="Switch to dark theme"
        >
          <title>Switch to dark theme</title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
      )}
    </button>
  )
}
